import { EntityChild } from 'app/shared/models/entity-child.model';
import { SizeGroupTypeEnum } from '../../enum/size-group-type.enum.model';
import { AutomaticDiscountGetDto } from '../../../../shared/models/automatic-discount.models';
import { MediaDTO } from '../../../../shared/models/media.models';
import { BasicCollectionDTO } from '../common/basic-collection.models';
import { PaletteColorDTO } from '../common/palette-color.models';
import { ProductTier, TierDTO } from '../settings/tier.model';
import { OrderedMediaVm, ProductTagDTO, SizeDTO } from './product.models';
import { PriceComputation } from 'app/shop/shared/models/product-variant';
import { PaletteLimitDTO } from 'app/shared/models/palette-limit.model';
import { TagDTO } from 'app/shared/models/tag.models';

export class VariantBaseDTO {
  id: number;
  productId: number;
  cost: number;
  code: string;
  extCode?: string;
  productExtCode?: string;
  availableQuantity: number;
  ean: string;
  visibleForPreOrder: boolean;
  visibleForReOrder: boolean;
  blockQuantityBasedReOrderVisibility: boolean;
  quantityBuyIncrement: number;
  productCode: string;
  productTitle: string;
  lastAppliedWholesaleDiscountPercentage: number;
  paletteLimit: PaletteLimitDTO;
  tags?: TagDTO[];
  extPaletteId?: number;
}

export class VariantBaseExentedDTO extends VariantBaseDTO {
  basicCollections: BasicCollectionDTO[];
  blankCellsEndDate: string;
  blankCellsDeliveryDate: string;
  // purchaseLimit: number;
  size: SizeDTO;
  palette: VariantPaletteDTO;
  automaticDiscounts?: AutomaticDiscountGetDto[];
  creationTime: string;
  lastModificationTime: string;
  creatorId: number;
  lastModifierId: number;
}
export class VariantDTO extends VariantBaseExentedDTO {
  media: MediaDTO[];
  priceComputation: PriceComputation;
}

export class VariantFullDTO extends VariantDTO {
  sizeId: number;
  teamId: number;
  declare productId: number;
  currency: string;
  paletteId: number;
  tiers: TierDTO[];
}

export class VariantVM extends VariantBaseExentedDTO {
  media: OrderedMediaVm[];
  tiers: ProductTier[];
  imagePath: string;
  pricelists: VariantPricelistDTO[];
  declare tags?: ProductTagDTO[];
  labels: EntityChild[];
  categories: EntityChild[];
  purposes: EntityChild[];
  teams: EntityChild[];
  constructor(init?: VariantVM) {
    super();
    Object.assign(this, init);
  }
}

export class VariantPutDTO {
  id: number;
  availableQuantity: number;
  ean: string;
  // purchaseLimit: number;
  blankCellsEndDate: string;
  blankCellsDeliveryDate: string;
  visibleForReOrder: boolean;
  visibleForPreOrder: boolean;
  cost: number;
  code: string;
  blockQuantityBasedReOrderVisibility: boolean;
  constructor(init?: VariantPutDTO) {
    Object.assign(this, init);
  }
}

export class VariantPricelistDTO {
  id: number;
  priceList: {
    id: number;
    currency: string;
    type: number;
    storeId: number;
  };
  variantId: number;
  variant: VariantFullDTO;
  priceListId: number;
  wholesalePrice: number;
  retailPrice: number;
}

export class VariantForCollapseVM extends VariantBaseDTO {
  imagePath: string;
  checked?: boolean;
  disabled?: boolean;
  sizeName: string;
  sizeGroup: SizeGroupTypeEnum;
  colorName: string;
  sizeId: number;
  paletteId: number;
  palette: VariantPaletteDTO;
  wholesalePrice: number;
  automaticDiscounts?: AutomaticDiscountGetDto[];
  productPaletteStockLimitId?: number;
  limit?: number;
  minimumQuantityForPreOrder?: number;
  minimumQuantityForReOrder?: number;
  constructor(init?: VariantForCollapseVM) {
    super();
    Object.assign(this, init);
  }
}

export class VariantPaletteDTO {
  id: number;
  description: string;
  externalColorCode: string;
  externalId: string;
  colors: PaletteColorDTO[];
}

// --- Modelli per l'endpoint price list variants (lista varianti con prezzi listino) ---

/** Style group come restituito nella risposta price list variants */
export interface PriceListVariantProductStyleGroupDTO {
  id: number;
  name: string;
  excludeFromStockLimitCheck: boolean;
  storeId?: number;

}

/** Team come restituito nella risposta price list variants */
export interface PriceListVariantTeamDTO {
  id: number;
  code: string | null;
  externalId: string;
  name: string;
}

/** Singolo elemento variante nella risposta GET variants per listino prezzi. Estende VariantFullDTO aggiungendo prezzi listino, gender, productStyleGroup e team. */
export class PriceListVariantElementDTO extends VariantFullDTO {
  defaultRetailPrice: number;
  defaultWholesalePrice: number;
  customRetailPrice: number;
  customWholesalePrice: number;
  storeSalePeriodFrom: string;
  storeSalePeriodTo: string;
  gender: number;
  productStyleGroup: PriceListVariantProductStyleGroupDTO;
  team: PriceListVariantTeamDTO;

  constructor(init?: PriceListVariantElementDTO) {
    super();
    Object.assign(this, init);
  }
}
